import React, { useEffect, useState } from 'react';
import HeaderCommun from './HeaderCommun';
import axios from 'axios';

const rawNavigation = [
  {
    name: 'Dashboard',
    href: '/recruteur/dashboard',
    permissionKey: 'dashboard'
  },
  {
    name: 'Missions',
    permissionKey: 'missions',
    children: [
      { name: 'Toutes les missions', href: '/recruteur/Allmissions', permissionKey: 'missions' },
      { name: 'Mes missions', href: '/recruteur/Mesmissions', permissionKey: 'missions' },
      { name: 'Mes favoris', href: '/recruteur/favoris', permissionKey: 'missions' }
    ]
  },
  {
    name: 'Mes Candidatures',
    href: '/recruteur/candidature',
    permissionKey: 'candidatures'
  },
  {
    name: 'Mes top matches',
    href: '/recruteur/top-matches',
    permissionKey: 'topmatches'
  },
  {
    name: 'Mes Talents',
    href: '/recruteur/talents',
    permissionKey: 'mesTalents'
  },
  {
    name: 'Mes statistiques',
    href: '/recruteur/recruteur-stats',
    permissionKey: 'recruteur-stats'
  }
];

const userNavigation = [
  { name: 'Profil', href: '/Recruteur/Profile' },
  { name: 'Mes statistiques', href: '/Recruteur/Statistiques' },
  { name: 'Factures', href: '/Factures' },
  { name: 'Garanties', href: '/Garanties' },
  { name: 'Aide', href: '/Aide' },
  { name: 'Se déconnecter' }
];

const HeaderRec = () => {
  const [filteredNav, setFilteredNav] = useState([]);
  const [cagnotte, setCagnotte] = useState(null);
  const [recruteurName, setRecruteurName] = useState(localStorage.getItem('recruteurName') || 'Recruteur');
  const [recruteurAvatar, setRecruteurAvatar] = useState(localStorage.getItem('recruteurAvatar') || null);

  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const MAX_SESSION_DURATION = 24 * 60 * 60 * 1000; 

  const checkAutoLogout = () => {
    const loginTime = localStorage.getItem("loginTime");

    if (loginTime) {
      const timeElapsed = Date.now() - parseInt(loginTime, 10);

      if (timeElapsed > MAX_SESSION_DURATION) {
        localStorage.clear();
      }
    }
  };
  useEffect(() => {
    const fetchPermissions = async () => {
      const userType = localStorage.getItem('userType');
      if (!userType) return;
      try {
        const res = await axios.get(`${API_BASE}/api/roles/${userType.toLowerCase()}/permissions`);
        const permissions = res.data || {};
        const navWithAccess = rawNavigation
          .map(item => {
            if (item.children) {
              const children = item.children.filter(child => permissions[child.permissionKey]?.Accès);
              return children.length > 0 ? { ...item, children } : null;
            } else {
              return permissions[item.permissionKey]?.Accès ? item : null;
            }
          })
          .filter(Boolean);
        setFilteredNav(navWithAccess);
      } catch {
        setFilteredNav([]);
      }
    };

    const fetchCagnotte = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const res = await axios.get(`${API_BASE}/api/recruteur-stats`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setCagnotte(res.data?.cagnotte || null);
      } catch {
        setCagnotte(null);
      }
    };

    const handleStorageUpdate = () => {
      setRecruteurName(localStorage.getItem("recruteurName") || 'Recruteur');
      setRecruteurAvatar(localStorage.getItem("recruteurAvatar") || null);
    };

    fetchPermissions();
    fetchCagnotte();
    checkAutoLogout();
    window.addEventListener("storage", handleStorageUpdate);
    return () => {
      window.removeEventListener("storage", handleStorageUpdate);
    };
  }, []);

  return (
    <HeaderCommun
      userName={recruteurName}
      navigation={filteredNav}
      userNavigation={userNavigation}
      cagnotte={cagnotte}
      userAvatar={recruteurAvatar ? `${API_BASE}${recruteurAvatar}?t=${Date.now()}` : null}
      addButtonLabel={null}
      addButtonHref={null}
      userRole="recruteur"
    />
  );
};

export default HeaderRec;
